var map = {
	"./Black-Bishop.svg": "./src/Assets/ChessPieces/Black-Bishop.svg",
	"./Black-King.svg": "./src/Assets/ChessPieces/Black-King.svg",
	"./Black-Knight.svg": "./src/Assets/ChessPieces/Black-Knight.svg",
	"./Black-Pawn.svg": "./src/Assets/ChessPieces/Black-Pawn.svg",
	"./Black-Queen.svg": "./src/Assets/ChessPieces/Black-Queen.svg",
	"./Black-Rook.svg": "./src/Assets/ChessPieces/Black-Rook.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Assets/ChessPieces sync recursive ^\\.\\/Black\\-.*\\.svg$";